export const ROUTE_BASE_NAME = "devices";

export const ROUTE_NAMES = {
  List: `${ROUTE_BASE_NAME}.list`,
  Create: `${ROUTE_BASE_NAME}.create`,
  Update: `${ROUTE_BASE_NAME}.update`,
};
